
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.738","height":"20.738"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#303030"}},[_c('path',{attrs:{"d":"M20.153 9.369H.583c-.323 0-.584.448-.584 1s.262 1 .584 1h19.57c.323 0 .584-.448.584-1s-.262-1-.584-1z"}}),_c('path',{attrs:{"d":"M9.368.584v19.57c0 .323.448.584 1 .584s1-.262 1-.584V.584c0-.323-.448-.584-1-.584s-1 .262-1 .584z"}})])])
          )
        }
      }
    